import { useRouter } from 'js/lib/useRouter';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';

// Ensures we do a full page refresh if multi-program home attempts to client-side route to single program page.
// The full page refresh will go through edge, which will direct the request to the correct app.
// If this is being hit, something went wrong and we likely need to update a React client-side routing link.
const RedirectToSingleProgramHomePage = () => {
  const router = useRouter();

  redirectClientOrServer(router.location.pathname + router.location.search);

  return null;
};

export default RedirectToSingleProgramHomePage;
